import { DialogTitle, IconButton, Typography } from "@mui/material";
import { palettes } from "../../themes/palletes";
import { ArrowBack, Close } from "@mui/icons-material";
import { backButton, closeButton } from "./sxprops";

interface StyledDialogTitleProps {
    actionType: "close" | "back" | "both";
    title: string;
    subtitle?: string;
    handleBack?: () => void;
    handleClose: () => void;
    testIdPrefix?: string;
}

const slugify = (value: string): string =>
    value
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");

const StyledDialogTitle: React.FC<StyledDialogTitleProps> = ({
    actionType,
    title,
    subtitle,
    handleClose,
    handleBack,
    testIdPrefix,
}) => {
    const scope = testIdPrefix ?? slugify(title);
    return (
        <DialogTitle
            sx={{
                backgroundColor: palettes.$oldAppBg,
                position: 'relative',
                px: "30px",
                pt: "20px",
            }}
        >
            <Typography color="primary.main" sx={{
                fontSize: {mobile: "16px", tablet:"20px"},
                ml: (actionType === "back" || actionType === "both") ? "30px" : 0
            }} >
                {title}
            </Typography>
            {subtitle &&
                <Typography variant="body2" color="text.secondary" sx={{
                    wordWrap: "break-word",
                    ml: (actionType === "back" || actionType === "both") ? "30px" : 0
                }}>
                    {subtitle}
                </Typography>}
            {(actionType === "close" || actionType === "both") && <IconButton
                id={`${scope}-close-button`}
                data-testid={`${scope}-close-button`}
                onClick={handleClose}
                sx={closeButton}
            >
                <Close />
            </IconButton>}


            {(actionType === "back" || actionType === "both") && <IconButton
                id={`${scope}-back-button`}
                data-testid={`${scope}-back-button`}
                onClick={handleBack}
                sx={backButton}
            >
                <ArrowBack />
            </IconButton>}
        </DialogTitle>
    );
}

export default StyledDialogTitle;